<!--
 * @Author: ext.chenghuan8
 * @Date: 2025-11-28 10:22:34
 * @LastEditors: ext.chenghuan8
 * @LastEditTime: 2025-12-02 11:34:13
 * @Description:
 * @contact_information: ext.chenghuan8@jd.com
-->
<template>
  <div class="home-box">
    <div class="home-items">
      <div style="height: 0.3rem;">
        <div style="font-size: 0.1rem;font-weight: 500;">个人中心</div>
        <div>管理您的个人信息、绩效和目标</div>
      </div>
      <div class="card" style="width: 1.88rem; height: 2.32rem;">
        <div class="info-card">
          <div class="avator-wrapper">
            <img :src="avatorUrl || userInfo.headImg || avatorUrlInit" class="avator" />
            <Upload class="upload-avator" :show-upload-list="false" :on-success="handleSuccess" :format="['jpg', 'jpeg', 'png']" :max-size="2048"
              :on-exceeded-size="handleMaxSize" :action="$baseUrl + '/sso/imageFile/uploadBgImage'">
              上传头像
            </Upload>
          </div>
        </div>
        <div class="info-box"></div>
        <div class="name-box">
          <div class="name">{{ userInfo.name }}</div>
          <div class="number">{{ $t('homePage.gh') }}:{{ userInfo.userCode }}</div>
          <div class="button-box">
            <div class="button" @click="doJumpExternalLinks">{{ $t('loginPage.wbll') }}</div>
            <div class="button" @click="certificatesLinks">{{ $t('homePage.zj') }}</div>
          </div>
        </div>
        <div class="border-bottom"></div>
        <div class="links-box">
          <div class="links-items" @click="languagesModalShow = !languagesModalShow, doGetLanguages()">
            <img src="../../assets/images/common/tool-language.png" class="tool-icon">
            <div>{{ $t('homePage.yy') }}</div>
          </div>
          <div class="links-items" @click="skinModalShow = !skinModalShow, doGetSkinList()">
            <img src="../../assets/images/common/tool-skin.png">
            <div>{{ $t('homePage.pf') }}</div>
          </div>
          <div class="links-items" @click="loginStyleModalShow = !loginStyleModalShow, doGetBgList()" v-show="isAdmin">
            <img src="../../assets/images/common/tool-agent.png">
            <div>{{ $t('homePage.bj') }}</div>
          </div>
          <div class="links-items" @click="agentModalShow = !agentModalShow, doGetAgentList()" v-show="!isAdmin">
            <img src="../../assets/images/common/tool-agent.png">
            <div>{{ $t('homePage.yh') }}</div>
          </div>
          <div class="links-items" @click="handleUpdatePwd">
            <img src="../../assets/images/common/tool-password.png">
            <div>{{ $t('loginPage.xgmm') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="home-items">
      <div style="height: 0.3rem;">
      </div>
      <div class="card" style="width: 5.26rem; height: 2.32rem;">
        <div class="card-header">基本信息</div>
        <div class="info-item">
          <div class="title">{{ $t('homePage.gh') }}</div>
          <div class="text">{{ userInfo.userCode }}</div>
        </div>
        <div class="info-item">
          <div class="title">{{ $t('homePage.zh') }}</div>
          <div class="text">{{ userInfo.userName }}</div>
        </div>
        <div class="info-item">
          <div class="title">{{ $t('homePage.gw') }}</div>
          <div class="text">{{ userInfo.deptName || '-' }}</div>
        </div>
        <div class="info-item">
          <div class="title">{{ $t('homePage.sj') }}</div>
          <div class="text">{{ userInfo.mobile || '-' }}</div>
        </div>
        <div class="info-item">
          <div class="title">{{ $t('homePage.yx') }}</div>
          <div class="text">{{ userInfo.email || '-' }}</div>
        </div>

      </div>
    </div>

    <!-- 切换语言 -->
    <Modal class-name="modal-container" v-model="languagesModalShow" width="450">
      <p slot="header" class="modal-title">{{ $t('homePage.xtyyxz') }}</p>
      <div class="modal-content">
        <div class="items" v-for="item in languageList" :key="item.id" @click="handleSetDefaultLanguage(item)">
          <p class="checked" v-show="item.isDefault === 1" :style="{ 'background-color': item.isDefault === 1 ? primaryColor : '#333' }">
            <Icon class="icon" type="md-checkmark" />
          </p>
          <template v-if="item.name.includes('中文简体')">
            <img src="../../assets/images/lan1.png" />
            <p class="name" :active="item.isDefault === 1" :style="{ 'color': item.isDefault === 1 ? primaryColor : '#333' }">{{ $t('homePage.zwjt') }}</p>
          </template>
          <template v-else-if="item.name.includes('中文繁体')">
            <img src="../../assets/images/lan2.png" />
            <p class="name" :active="item.isDefault === 1" :style="{ 'color': item.isDefault === 1 ? primaryColor : '#333' }">{{ $t('homePage.zwft') }}</p>
          </template>
          <template v-else-if="['英文', 'english', 'English'].includes(item.name)">
            <img src="../../assets/images/lan3.png" />
            <p class="name" :active="item.isDefault === 1" :style="{ 'color': item.isDefault === 1 ? primaryColor : '#333' }">{{ $t('homePage.yw') }}</p>
          </template>
          <template v-else-if="['泰语'].includes(item.name)">
            <img src="../../assets/images/lan4.png" />
            <p class="name" :active="item.isDefault === 1" :style="{ 'color': item.isDefault === 1 ? primaryColor : '#333' }">{{ $t('homePage.ty') }}</p>
          </template>
          <template v-else-if="['韩语'].includes(item.name)">
            <img src="../../assets/images/lan5.png" />
            <p class="name" :active="item.isDefault === 1" :style="{ 'color': item.isDefault === 1 ? primaryColor : '#333' }">{{ $t('homePage.hy') }}</p>
          </template>
          <template v-else>
            <img src="../../assets/images/logo1.png" />
            <p class="name" :active="item.isDefault === 1" :style="{ 'color': item.isDefault === 1 ? primaryColor : '#333' }">{{ item.name }}</p>
          </template>
        </div>
      </div>
      <div slot="footer" class="modal-footer">
        <Button class="button" shape="circle" @click="languagesModalShow = false, doGetLanguages()">{{ $t('qx') }}</Button>
        <Button class="button" type="primary" shape="circle" @click="doSetDefaultLanguage">{{ $t('qr') }}</Button>
      </div>
    </Modal>

    <!-- 切换登录背景效果 -->
    <Modal class-name="modal-container" v-model="loginStyleModalShow" width="450" v-show="isAdmin">
      <p slot="header" class="modal-title">{{ $t('homePage.dlbjxgqh') }}</p>
      <div class="modal-content">
        <div class="items" v-for="item in bgList" :key="item.id" @click="handleSetBg(item)">
          <p class="checked" :style="{ 'background-color': item.isDefault === 1 ? primaryColor : '#333' }" v-show="item.isDefault === 1">
            <Icon class="icon" type="md-checkmark" />
          </p>
          <svg class="icon icon-normal text-color" aria-hidden="true" v-show="item.bgLayout === 'center'">
            <use xlink:href="#icon-bac2"></use>
          </svg>
          <svg class="icon icon-normal text-color" aria-hidden="true" v-show="item.bgLayout === 'right'">
            <use xlink:href="#icon-bac3"></use>
          </svg>
          <span class="bj-light" :style="{ 'background-color': lightColor }"></span>
          <p class="back-name" :active="item.isDefault === 1" :style="{ 'color': item.isDefault === 1 ? primaryColor : '#333' }">{{ item.subject }}</p>
        </div>
      </div>
      <div slot="footer" class="modal-footer">
        <Button class="button" shape="circle" @click="loginStyleModalShow = false, doGetBgList()">{{ $t('qx') }}</Button>
        <Button class="button" type="primary" shape="circle" @click="doSetBg">{{ $t('qr') }}</Button>
      </div>
    </Modal>

    <!-- 切换代理人 -->
    <Modal class-name="modal-container" v-model="agentModalShow" width="450" v-show="!isAdmin">
      <p slot="header" class="modal-title">{{ $t('homePage.qhdlr') }}</p>
      <div class="modal-content" v-if="agentList.length > 0">
        <div class="items" v-for="item in agentList" :key="item.id" @click="handleSetAgent(item)">
          <p class="checked" v-show="item.isDefault === 1" :style="{ 'background-color': item.isDefault === 1 ? primaryColor : '#333' }">
            <Icon class="icon" type="md-checkmark" />
          </p>
          <img :src="item.headImg" v-if="item.headImg" />
          <img src="../../assets/images/avator.png" v-else />
          <p class="name back-name" :active="item.isDefault === 1" :style="{ 'color': item.isDefault === 1 ? primaryColor : '#333' }">{{ item.agentUserName }}</p>
          <p class="name back-name" :active="item.isDefault === 1" :style="{ 'color': item.isDefault === 1 ? primaryColor : '#333' }">{{ item.agentUserCode }}</p>
        </div>
      </div>
      <div class="modal-content modal-content-center" v-else>
        空
      </div>
      <div slot="footer" class="modal-footer">
        <Button class="button" shape="circle" @click="agentModalShow = false, doGetAgentList()">{{ $t('qx') }}</Button>
        <Button class="button" type="primary" shape="circle" @click="doSetAgent">{{ $t('qr') }}</Button>
      </div>
    </Modal>

    <!-- 切换皮肤 -->
    <Modal class-name="modal-container" v-model="skinModalShow" width="450">
      <p slot="header" class="modal-title">{{ $t('homePage.xtpfqh') }}</p>
      <div class="modal-content">
        <div class="items" v-for="item in skinList" :key="item.id" @click="handleSetDefaultSkin(item)">
          <p class="checked" v-show="item.isDefault === 1" :style="{ 'background-color': item.isDefault === 1 ? primaryColor : '#333' }">
            <Icon class="icon" type="md-checkmark" />
          </p>
          <p class="skin-box" :style="{ 'background': item.skinColor }"></p>
        </div>
      </div>
      <div slot="footer" class="modal-footer">
        <Button class="button" shape="circle" @click="skinModalShow = false, doCancelSkin">{{ $t('qx') }}</Button>
        <Button class="button" type="primary" shape="circle" @click="doSetDefaultSkin">{{ $t('qr') }}</Button>
      </div>
    </Modal>

    <!-- 修改密码 -->
    <Modal class-name="modal-container" v-model="pwdModalShow" @on-cancel="doResetForm" width="450">
      <p slot="header" class="modal-title">{{ $t('loginPage.xgmm') }}</p>
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120" style="width: 80%;">
        <FormItem :label="$t('loginPage.ymm')" prop="oldPassword">
          <Input v-model="formValidate.oldPassword" :placeholder="$t('loginPage.ymm')" type="password" password></Input>
        </FormItem>
        <FormItem :label="$t('loginPage.xmm')" prop="password">
          <Input v-model="formValidate.password" :placeholder="$t('loginPage.xmm')" type="password" password @on-change="pwdChange"></Input>
        </FormItem>
        <FormItem :label="$t('loginPage.qrxmm')" prop="newPassword">
          <Input v-model="formValidate.newPassword" :placeholder="$t('loginPage.qrxmm')" type="password" password @on-change="inconsistentChange"></Input>
        </FormItem>
      </Form>
      <div class="error-msg" v-show="errMsgFlag">
        <div>
          <Icon type="ios-checkmark-circle-outline" color="green" size="18" v-show="!fontFlag" />
          <Icon type="ios-close-circle-outline" color="red" size="18" v-show="fontFlag" />
          {{ $t('loginPage.cdbzf') }}
        </div>
        <div>
          <Icon type="ios-checkmark-circle-outline" color="green" size="18" v-show="!pwdFlag" />
          <Icon type="ios-close-circle-outline" color="red" size="18" v-show="pwdFlag" />
          {{ $t('loginPage.sgcfzf') }}
        </div>
        <div>
          <Icon type="ios-checkmark-circle-outline" color="green" size="18" v-show="useFlag" />
          <Icon type="ios-close-circle-outline" color="red" size="18" v-show="!useFlag" />
          {{ $t('loginPage.bbhyhm') }}
        </div>
        <div>
          <Icon type="ios-checkmark-circle-outline" color="green" size="18" v-show="!fourFlag" />
          <Icon type="ios-close-circle-outline" color="red" size="18" v-show="fourFlag" />
          {{ $t('loginPage.bhtszf') }}
        </div>
        <div v-show="inconsistent">
          <Icon type="ios-checkmark-circle-outline" color="green" size="18" v-show="!consistentFlag" />
          <Icon type="ios-close-circle-outline" color="red" size="18" v-show="consistentFlag" />
          {{ $t('loginPage.mmbyz') }}
        </div>
        <div class="qd-msg" id="tips">
          <div class="msg-item">弱</div>
          <div class="msg-item"></div>
          <div class="msg-item"></div>
          <div class="msg-item">强</div>
        </div>
      </div>
      <p style="padding: 0 24px;">{{ $t('mmzs') }}</p>
      <div slot="footer" class="modal-footer">
        <Button class="button" shape="circle" @click="doResetForm">{{ $t('qx') }}</Button>
        <Button :loading="updatePwd" class="button" type="primary" shape="circle" @click="doUpdatePwd">{{ $t('qr') }}</Button>
      </div>
    </Modal>

    <!-- 证件提醒 -->
    <Modal class-name="modal-container" @on-cancel="getCertificatesList()" v-model="certificatesShow" :mask-closable="false" width="1250">
      <p slot="header" class="modal-title">{{ $t('homePage.zjtx') }}</p>
      <div class="search-btn">
        <div class="btn-left">
          <div class="btn-item" :class="btnAcitve == 0 ? 'btnActive' : ''" @click="saerchCertificates('', 0)">全部</div>
          <div class="btn-item" :class="btnAcitve == 1 ? 'btnActive' : ''" @click="saerchCertificates('syq', 1), syqSave('')">试用期</div>
          <div class="btn-item" :class="btnAcitve == 2 ? 'btnActive' : ''" @click="saerchCertificates('ht', 2), htSave('')">合同</div>
          <div class="btn-item" :class="btnAcitve == 3 ? 'btnActive' : ''" @click="saerchCertificates('tx', 3), txSave('')">退休</div>
          <div class="btn-item" :class="btnAcitve == 4 ? 'btnActive' : ''" @click="saerchCertificates('jkz', 4), jkzSave('')">健康证</div>
          <div class="btn-item" :class="btnAcitve == 5 ? 'btnActive' : ''" @click="saerchCertificates('sr', 5), srSave('')">生日</div>
          <div class="btn-item" :class="btnAcitve == 6 ? 'btnActive' : ''" @click="saerchCertificates('zn', 6), znSave('')">周年</div>
          <div class="btn-item" :class="btnAcitve == 7 ? 'btnActive' : ''" @click="saerchCertificates('htzz', 7), htzzSave('')">兼职</div>
          <div class="btn-item" :class="btnAcitve == 8 ? 'btnActive' : ''" @click="saerchCertificates('cert', 8), certSave('')">证书</div>
        </div>
        <div class="btn-right">
          <Button class="button" type="primary" @click="doExport">导出</Button>
        </div>
      </div>
      <div class="modal-content" style="height: 520px;">
        <div style="width: 100%;" v-show="btnAcitve === 0">
          <div v-if="zjList.length > 0">
            <table style="width: 96%;margin: 1% 2% 0" border="1px" cellpadding="10px">
              <tr>
                <th style="width: 5%;padding: 8px;">#</th>
                <th style="width: 85%;padding: 8px;">标题</th>
                <th style="width: 10%;padding: 8px;">操作</th>
              </tr>
              <tr v-for="(item, index) in zjList" :key="index">
                <td style="text-align: center;">{{ index + 1 }}</td>
                <td style="padding-left: 10px;">{{ item.remind_msg }}</td>
                <td style="text-align: center;padding: 5px 0">
                  <Button class="button" type="primary" @click="qrCertificates(item)" :disabled="item.status">{{ item.text }}</Button>
                </td>
              </tr>
            </table>
          </div>
          <div v-else>暂无数据</div>
        </div>
        <!-- 其他分类的表格类似，这里简化处理 -->
        <div style="width: 100%;" v-show="btnAcitve === 1">
          <div v-if="syqList.length > 0">
            <table style="width: 96%;margin: 1% 2% 0" border="1px" cellpadding="10px">
              <tr>
                <th style="width: 5%;padding: 8px;">#</th>
                <th style="width: 85%;padding: 8px;">标题</th>
                <th style="width: 10%;padding: 8px;">操作</th>
              </tr>
              <tr v-for="(item, index) in syqList" :key="index">
                <td style="text-align: center;">{{ index + 1 }}</td>
                <td style="padding-left: 10px;">{{ item.remind_msg }}</td>
                <td style="text-align: center;padding: 5px 0">
                  <Button class="button" type="primary" @click="syqSave(item)" :disabled="item.status">{{ item.text }}</Button>
                </td>
              </tr>
            </table>
          </div>
          <div v-else>暂无数据</div>
        </div>
        <!-- 其他分类类似，省略 -->
      </div>
    </Modal>
  </div>
</template>

<script>
import { session, cookie } from '@/libs/location'
export default {
  name: 'center',
  components: {},
  data () {
    return {
      userInfo: {},
      avatorUrlInit: require('../../assets/images/avator.png'),
      avatorUrl: '',
      lightColor: '',
      primaryColor: '',
      isAdmin: false,
      languagesModalShow: false,
      languageList: [],
      skinModalShow: false,
      skinList: [],
      loginStyleModalShow: false,
      bgList: [],
      agentModalShow: false,
      agentList: [],
      pwdModalShow: false,
      formValidate: {
        oldPassword: '',
        password: '',
        newPassword: ''
      },
      ruleValidate: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' }
        ]
      },
      updatePwd: false,
      fontFlag: false,
      pwdFlag: false,
      useFlag: false,
      fourFlag: false,
      consistentFlag: false,
      inconsistent: false,
      qdMsgFlag: 0,
      errMsgFlag: false,
      certificatesShow: false,
      certificatesList: [],
      btnAcitve: 0,
      syqList: [],
      htList: [],
      txList: [],
      jkzList: [],
      srList: [],
      znList: [],
      htzzList: [],
      certList: [],
      zjList: []
    }
  },
  computed: {},
  created () {
    // 先从缓存获取 userInfo
    const cachedUserInfo = JSON.parse(session.getItem('userInfo')) || {}
    this.userInfo = cachedUserInfo
    // 立即设置 CSS 变量，确保页面加载时就能使用正确的颜色
    if (cachedUserInfo.skinColor) {
      document.documentElement.style.setProperty('--primary-color', cachedUserInfo.skinColor)
    }
    // 调用接口获取最新用户信息并合并
    this.doGetUserInfo()
  },
  methods: {
    // 获取用户信息（合并缓存和接口数据）
    doGetUserInfo () {
      // 获取缓存数据
      const cachedUserInfo = JSON.parse(session.getItem('userInfo')) || {}

      // 调用接口获取最新用户信息
      this.$request.post('/sso/userAttr/findUserInfo').then(res => {
        const { code, data } = res.data
        if (code === 'OK' && data) {
          // 合并缓存和接口数据（接口数据优先，但保留缓存中可能存在的额外字段）
          this.userInfo = { ...cachedUserInfo, ...data }
          // 更新缓存
          session.setItem('userInfo', JSON.stringify(this.userInfo))
        } else {
          // 接口失败时使用缓存数据
          this.userInfo = cachedUserInfo
        }
      }).catch(() => {
        // 接口调用失败时使用缓存数据
        this.userInfo = cachedUserInfo
      }).finally(() => {
        // 无论成功失败都执行初始化
        this.initUserInfo()
      })
    },
    // 初始化用户信息相关操作
    initUserInfo () {
      if (!this.userInfo || Object.keys(this.userInfo).length === 0) {
        return
      }

      this.avatorUrl = this.userInfo.headImg
      this.isAdmin = this.userInfo.id === 0

      // 初始化颜色
      if (this.userInfo.skinColor) {
        let _color = this.handleTurnColorRgb(this.userInfo.skinColor)
        this.lightColor = `rgba(${_color[0]}, ${_color[1]}, ${_color[2]}, .2)`
        this.primaryColor = `rgb(${_color[0]}, ${_color[1]}, ${_color[2]})`
        // 初始化时设置 primary-color CSS 变量
        document.documentElement.style.setProperty('--primary-color', this.userInfo.skinColor)
      }

      // 初始化获取证书列表
      this.getCertificatesList()
    },
    doJumpExternalLinks () {
      // this.showLinks = !this.showLinks
      let newpage = this.$router.resolve({ name: 'link' })
      window.open(newpage.href, 'ssoexl')
    },
    certificatesLinks () {
      if (this.certificatesList.length > 0) {
        this.certificatesShow = true
        this.btnAcitve = 0
        this.getCertificatesList()
      }
    },
    getCertificatesList () {
      this.syqList = []
      this.htList = []
      this.txList = []
      this.jkzList = []
      this.srList = []
      this.znList = []
      this.certificatesList = []
      this.zjList = []
      // 兼职
      this.htzzList = []
      // 证书
      this.certList = []
      this.$request.post('/sso/hrUserAttrRemind/findUserRemindList', { 'sourceUserId': JSON.parse(session.getItem('userInfo')).sourceUserId }).then(res => {
        if (res.data.data.list.length > 0) {
          let list = res.data.data.list
          list.forEach(item => {
            item.status = false
            item.text = '确认'
            if (item.data_type === 'syq') {
              this.syqList.push(item)
            }
            if (item.data_type === 'ht') {
              this.htList.push(item)
            }
            if (item.data_type === 'tx') {
              this.txList.push(item)
            }
            if (item.data_type === 'jkz') {
              this.jkzList.push(item)
            }
            if (item.data_type === 'sr') {
              this.srList.push(item)
            }
            if (item.data_type === 'zn') {
              this.znList.push(item)
            }
            if (item.data_type === 'htzz') {
              this.htzzList.push(item)
            }
            if (item.data_type.includes('cert')) {
              this.certList.push(item)
            }
          })
          this.certificatesList = list
          this.zjList = list
        } else {
          this.syqList = []
          this.htList = []
          this.txList = []
          this.jkzList = []
          this.srList = []
          this.znList = []
          this.certificatesList = []
          this.zjList = []
          this.htzzList = []
          this.certList = []
        }
      })
    },
    // 上传成功
    handleSuccess (res, file) {
      this.avatorUrl = res.data.url
      this.$request.post('/sso/userAttr/addOrUpdate', { headImg: this.avatorUrl }).then(res => {
        const { code } = res.data
        if (code === 'OK') {
          this.$Message.success(this.$t('czcg'))
          // 更新用户信息
          this.userInfo.headImg = this.avatorUrl
          session.setItem('userInfo', JSON.stringify(this.userInfo))
        }
      })
    },
    // 上传大小控制
    handleMaxSize (file) {
      this.$Message.warning('照片  ' + file.name + ' 太大, 最大不超过 2M.')
    },
    // 获取语言列表
    doGetLanguages () {
      this.$request.post('/sso/language/findList').then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          this.languageList = data.map(n => {
            if (JSON.parse(session.getItem('language'))) {
              if (n.keySign === JSON.parse(session.getItem('language')).languageSign) {
                n.isDefault = 1
              } else {
                n.isDefault = 0
              }
              return n
            } else {
              if (n.keySign === JSON.parse(session.getItem('userInfo')).languageSign) {
                n.isDefault = 1
              } else {
                n.isDefault = 0
              }
              return n
            }
          })
        }
      })
    },
    // 语言选择效果
    handleSetDefaultLanguage (item) {
      this.languageList.forEach(n => {
        if (n.keySign === item.keySign) {
          n.isDefault = 1
        } else {
          n.isDefault = 0
        }
      })
    },
    // 设置默认语言列表
    doSetDefaultLanguage () {
      this.languagesModalShow = false
      let _data = this.languageList.find(n => n.isDefault === 1)
      this.$i18n.locale = _data.keySign
      this.$request.post('/sso/userAttr/addOrUpdate', { languageSign: _data.keySign }).then(res => {
        const { code } = res.data
        if (code === 'OK') {
          let _userInfo = JSON.parse(session.getItem('userInfo'))
          _userInfo.languageSign = _data.keySign
          _userInfo.languageChar = _data.languageChar
          this.userInfo = _userInfo
          session.setItem('userInfo', JSON.stringify(_userInfo))
          this.$Message.success(this.$t('czcg'))
        }
      })
    },
    // 获取预置背景列表
    doGetBgList () {
      this.$request.post('/sso/backgroundSet/findList').then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          this.bgList = data.map(n => {
            if (n.id === this.$store.state.settingData.id) {
              n.isDefault = 1
            } else {
              n.isDefault = 0
            }
            return n
          })
        }
      })
    },
    // 背景切换效果
    handleSetBg (item) {
      this.bgList.forEach(n => {
        if (n.id === item.id) {
          n.isDefault = 1
        } else {
          n.isDefault = 0
        }
      })
    },
    // 设置登录背景效果切换
    doSetBg () {
      this.loginStyleModalShow = false
      let _data = this.bgList.find(n => n.isDefault === 1)
      this.$request.post('/sso/backgroundSet/updateIsUse', { id: _data.id }).then(res => {
        const { code } = res.data
        if (code === 'OK') {
          this.$store.commit('handleSettingData', _data)
          this.$Message.success(this.$t('czcg'))
        }
      })
    },
    // 获取代理人列表
    doGetAgentList () {
      // 确保能获取到 userId，优先使用 this.userInfo，否则从 session 中获取
      let userId = null
      if (this.userInfo && (this.userInfo.userId || this.userInfo.id)) {
        userId = this.userInfo.userId || this.userInfo.id
      } else {
        const userInfo = JSON.parse(session.getItem('userInfo'))
        userId = userInfo ? userInfo.userId || userInfo.id : null
      }

      if (!userId) {
        this.$Message.error('获取用户信息失败，请刷新页面重试')
        return
      }

      this.$request.post('/sso/userAgent/findUserAgent', { userId: userId }).then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          this.agentList = data.map(n => {
            n.isDefault = 0
            return n
          })
        }
      })
    },
    // 代理人切换效果
    handleSetAgent (item) {
      this.agentList.forEach(n => {
        if (n.agentUserId === item.agentUserId) {
          n.isDefault = 1
        } else {
          n.isDefault = 0
        }
      })
    },
    // 切换设置代理人
    doSetAgent () {
      this.agentModalShow = false
      let _data = this.agentList.find(n => n.isDefault === 1)
      this.$request.post('/sso/login/userLoginForAgent', { id: _data.agentUserId }).then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          session.clear()
          session.setObject(data.sessionId)
          session.setItem('userInfo', JSON.stringify(data))
          cookie.setCookie('token', data.sessionId)
          cookie.setCookie('userInfo', JSON.stringify(data))
          if (this.$route.query.token) {
            this.$router.replace({ name: 'center', query: { 'token': data.sessionId, 'key': Math.random() } })
            setTimeout(() => {
              this.$router.go(0)
            }, 200)
          } else {
            this.$router.push({ name: 'center' })
            window.location.reload()
          }
        }
      })
    },
    // 获取皮肤列表
    doGetSkinList () {
      this.$request.post('/sso/userAttr/findSkinColor').then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          let _skinList = JSON.parse(JSON.stringify(data))
          this.skinList = _skinList.map(k => {
            if (k.skinColor === JSON.parse(session.getItem('userInfo')).skinColor) {
              k.isDefault = 1
            } else {
              k.isDefault = 0
            }
            return k
          })
        }
      })
    },
    // 皮肤切换效果
    handleSetDefaultSkin (item) {
      this.skinList.forEach(n => {
        if (n.skinColor === item.skinColor) {
          n.isDefault = 1
        } else {
          n.isDefault = 0
        }
      })
    },
    // 恢复原皮肤
    doCancelSkin () {
      this.skinList.forEach(n => {
        if (n.skinColor === JSON.parse(session.getItem('userInfo')).skinColor) {
          n.isDefault = 1
        } else {
          n.isDefault = 0
        }
      })
    },
    // 切换设置皮肤
    doSetDefaultSkin () {
      let _data = this.skinList.find(n => n.isDefault === 1)
      this.$store.dispatch('doChangeSkin', _data.skinColor)
      let _color = this.handleTurnColorRgb(_data.skinColor)
      this.lightColor = `rgba(${_color[0]}, ${_color[1]}, ${_color[2]}, .2)`
      this.primaryColor = `rgb(${_color[0]}, ${_color[1]}, ${_color[2]})`
      // 动态更新 primary-color CSS 变量
      document.documentElement.style.setProperty('--primary-color', _data.skinColor)
      // 强制触发样式重新计算，确保所有使用 CSS 变量的元素都能更新
      this.$nextTick(() => {
        // 通过添加和移除一个临时类来强制浏览器重新计算样式
        document.documentElement.classList.add('theme-updated')
        // 强制重新计算所有样式
        void document.documentElement.offsetHeight
        setTimeout(() => {
          document.documentElement.classList.remove('theme-updated')
        }, 0)
      })
      this.skinModalShow = false
      this.$request.post('/sso/userAttr/addOrUpdate', { skinColor: _data.skinColor }).then(res => {
        const { code } = res.data
        if (code === 'OK') {
          let _userInfo = JSON.parse(session.getItem('userInfo'))
          _userInfo.skinColor = _data.skinColor
          session.setItem('userInfo', JSON.stringify(_userInfo))
          this.userInfo = _userInfo
          this.$Message.success(this.$t('czcg'))
          // 切换成功后，触发全局事件通知其他组件更新
          this.$root.$emit('theme-color-changed', _data.skinColor)
        }
      })
    },
    // 修改密码
    handleUpdatePwd () {
      this.pwdModalShow = true
    },
    // 取消修改密码
    doResetForm () {
      this.formValidate = {
        oldPassword: '',
        password: '',
        newPassword: ''
      }
      this.pwdModalShow = false
      this.errMsgFlag = false
    },
    // 16进制颜色值换算成rgb值
    handleTurnColorRgb (colorStr) {
      let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
      let color = colorStr.toLowerCase()
      if (reg.test(color)) {
        if (color.length === 4) {
          let colorNew = '#'
          for (let i = 1; i < 4; i += 1) {
            colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1))
          }
          color = colorNew
        }
        let colorChange = []
        for (let i = 1; i < 7; i += 2) {
          colorChange.push(parseInt('0x' + color.slice(i, i + 2)))
        }
        return colorChange
      } else {
        return [0, 168, 254]
      }
    },
    // 修改密码检验
    pwdChange () {
      this.qdMsgFlag = 0
      if (this.formValidate.password) {
        this.errMsgFlag = true
      } else {
        this.errMsgFlag = false
      }
      if (this.formValidate.password.length >= 8) {
        this.fontFlag = false
        this.qdMsgFlag += 1
      } else {
        this.fontFlag = true
      }
      let reg = !window.document.location.origin.includes('hello.') ? /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[-!@#$%^&*()_+|~=`{}[\]:";'<>?,./]).{4,30}$/ : /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[@#])[\da-zA-Z~@#]{4,30}$/
      if (reg.test(this.formValidate.password)) {
        this.fourFlag = false
        this.qdMsgFlag += 1
      } else {
        this.fourFlag = true
      }
      let LxStr = function (str) {
        var arr = str.split('')
        var flag = true
        for (var i = 1; i < arr.length - 1; i++) {
          var firstIndex = arr[i - 1].charCodeAt()
          var secondIndex = arr[i].charCodeAt()
          var thirdIndex = arr[i + 1].charCodeAt()
          if ((thirdIndex - secondIndex === 1) && (secondIndex - firstIndex === 1)) {
            flag = false
          }
        }
        return flag
      }
      let re = /(\w)*(\w)\2{2}(\w)*/g
      if (!LxStr(this.formValidate.password) || re.test(this.formValidate.password)) {
        this.pwdFlag = true
      } else {
        this.pwdFlag = false
        this.qdMsgFlag += 1
      }
      let userName = JSON.parse(session.getItem('userInfo')).userName
      if (this.formValidate.password.includes(userName) || this.reverseString(this.formValidate.password).includes(userName)) {
        this.useFlag = false
      } else {
        this.useFlag = true
        this.qdMsgFlag += 1
      }
      // 更新密码强度提示
      this.$nextTick(() => {
        const tips = document.getElementById('tips')
        if (tips) {
          const tipItems = tips.getElementsByTagName('div')
          switch (this.qdMsgFlag) {
            case 0:
              break
            case 1:
              tipItems[0].style.backgroundColor = 'red'
              tipItems[0].innerText = this.$t('loginPage.rx')
              tipItems[1].style.backgroundColor = 'lightGray'
              tipItems[2].style.backgroundColor = 'lightGray'
              tipItems[3].style.backgroundColor = 'lightGray'
              tipItems[3].innerText = ''
              break
            case 2:
              tipItems[0].style.backgroundColor = 'red'
              tipItems[0].innerText = this.$t('loginPage.rx')
              tipItems[1].style.backgroundColor = 'lightGray'
              tipItems[2].style.backgroundColor = 'lightGray'
              tipItems[3].style.backgroundColor = 'lightGray'
              tipItems[3].innerText = ''
              break
            case 3:
              tipItems[0].style.backgroundColor = 'red'
              tipItems[0].innerText = this.$t('loginPage.rx')
              tipItems[1].style.backgroundColor = 'lightGray'
              tipItems[2].style.backgroundColor = 'lightGray'
              tipItems[3].style.backgroundColor = 'lightGray'
              tipItems[3].innerText = ''
              break
            case 4:
              tipItems[0].style.backgroundColor = 'lightGray'
              tipItems[0].innerText = ''
              tipItems[1].style.backgroundColor = 'lightGray'
              tipItems[2].style.backgroundColor = 'lightGray'
              tipItems[3].style.backgroundColor = 'lightGreen'
              tipItems[3].innerText = this.$t('loginPage.qd')
              break
          }
        }
      })
    },
    reverseString (str) {
      return str.split('').reverse().join('')
    },
    // 两次密码不一致检验
    inconsistentChange () {
      if (this.formValidate.newPassword) {
        this.inconsistent = true
      } else {
        this.inconsistent = false
      }
      if (this.formValidate.password !== this.formValidate.newPassword) {
        this.consistentFlag = true
      } else {
        this.consistentFlag = false
      }
    },
    // 确认修改密码
    doUpdatePwd () {
      if (this.formValidate.password !== this.formValidate.newPassword) {
        this.consistentFlag = true
        this.inconsistent = true
      } else {
        this.consistentFlag = false
      }
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          if (this.fontFlag) {
            return false
          }
          if (this.pwdFlag) {
            return false
          }
          if (!this.useFlag) {
            return false
          }
          if (this.fourFlag) {
            return false
          }
          if (this.consistentFlag) {
            return false
          }
          this.updatePwd = true
          let req = {
            userCode: this.userInfo.userName,
            password: this.formValidate.password,
            oldPassword: this.formValidate.oldPassword,
            sessionId: this.userInfo.sessionId
          }
          this.$request.post('/sso/login/modPasswordForFirst', req).then(res => {
            const { code } = res.data
            if (code === 'OK') {
              this.updatePwd = false
              this.doResetForm()
              this.$Message.success(this.$t('czcg'))
              this.pwdModalShow = false
            } else {
              this.updatePwd = false
            }
          })
        }
      })
    },
    // 搜索证书
    saerchCertificates (data, num) {
      this.btnAcitve = num
    },
    // 导出
    doExport () {
      let params = {
        sourceUserId: JSON.parse(session.getItem('userInfo')).sourceUserId
      }
      this.$request.post('/sso/hrUserAttrRemind/findUserRemindListForExport', params, 'blob').then(res => {
        let postfix = 'xlsx'
        const aLink = document.createElement('a')
        let blob = new Blob([res.data], { type: 'text/plain' })
        aLink.href = window.URL.createObjectURL(blob)
        aLink.download = `${this.$t('route.sftx')}.${postfix}`
        aLink.click()
        document.body.appendChild(aLink)
      })
    },
    // 全部确认
    qrCertificates (item) {
      if (item !== '') {
        item.status = true
        item.text = '已确认'
      }
      const wqrList = []
      const qrList = []
      const list = this.zjList
      list.forEach(item => {
        if (!item.status) {
          wqrList.push(item)
        } else {
          qrList.push(item)
        }
      })
      this.zjList = []
      this.zjList = [...wqrList, ...qrList]
      if (item !== '') {
        this.$request.post('/sso/hrUserAttrRemind/updateStatus', { 'id': item.id }).then(res => {
          if (res.data.code === 'OK') {
            this.$Message.success('操作成功')
          } else {
            this.$Message.warning('操作失败')
          }
        })
      }
    },
    // 试用期确认
    syqSave (data) {
      if (data !== '') {
        data.status = true
        data.text = '已确认'
      }
      const wqrList = []
      const qrList = []
      const list = this.syqList
      list.forEach(item => {
        if (!item.status) {
          wqrList.push(item)
        } else {
          qrList.push(item)
        }
      })
      this.syqList = []
      this.syqList = [...wqrList, ...qrList]
      if (data !== '') {
        this.$request.post('/sso/hrUserAttrRemind/updateStatus', { 'id': data.id }).then(res => {
          if (res.data.code === 'OK') {
            this.$Message.success('操作成功')
          } else {
            this.$Message.warning('操作失败')
          }
        })
      }
    },
    // 合同确认
    htSave (data) {
      if (data !== '') {
        data.status = true
        data.text = '已确认'
      }
      const wqrList = []
      const qrList = []
      const list = this.htList
      list.forEach(item => {
        if (!item.status) {
          wqrList.push(item)
        } else {
          qrList.push(item)
        }
      })
      this.htList = []
      this.htList = [...wqrList, ...qrList]
      if (data !== '') {
        this.$request.post('/sso/hrUserAttrRemind/updateStatus', { 'id': data.id }).then(res => {
          if (res.data.code === 'OK') {
            this.$Message.success('操作成功')
          } else {
            this.$Message.warning('操作失败')
          }
        })
      }
    },
    // 退休确认
    txSave (data) {
      if (data !== '') {
        data.status = true
        data.text = '已确认'
      }
      const wqrList = []
      const qrList = []
      const list = this.txList
      list.forEach(item => {
        if (!item.status) {
          wqrList.push(item)
        } else {
          qrList.push(item)
        }
      })
      this.txList = []
      this.txList = [...wqrList, ...qrList]
      if (data !== '') {
        this.$request.post('/sso/hrUserAttrRemind/updateStatus', { 'id': data.id }).then(res => {
          if (res.data.code === 'OK') {
            this.$Message.success('操作成功')
          } else {
            this.$Message.warning('操作失败')
          }
        })
      }
    },
    // 健康证确认
    jkzSave (data) {
      if (data !== '') {
        data.status = true
        data.text = '已确认'
      }
      const wqrList = []
      const qrList = []
      const list = this.jkzList
      list.forEach(item => {
        if (!item.status) {
          wqrList.push(item)
        } else {
          qrList.push(item)
        }
      })
      this.jkzList = []
      this.jkzList = [...wqrList, ...qrList]
      if (data !== '') {
        this.$request.post('/sso/hrUserAttrRemind/updateStatus', { 'id': data.id }).then(res => {
          if (res.data.code === 'OK') {
            this.$Message.success('操作成功')
          } else {
            this.$Message.warning('操作失败')
          }
        })
      }
    },
    // 生日确认
    srSave (data) {
      if (data !== '') {
        data.status = true
        data.text = '已确认'
      }
      const wqrList = []
      const qrList = []
      const list = this.srList
      list.forEach(item => {
        if (!item.status) {
          wqrList.push(item)
        } else {
          qrList.push(item)
        }
      })
      this.srList = []
      this.srList = [...wqrList, ...qrList]
      if (data !== '') {
        this.$request.post('/sso/hrUserAttrRemind/updateStatus', { 'id': data.id }).then(res => {
          if (res.data.code === 'OK') {
            this.$Message.success('操作成功')
          } else {
            this.$Message.warning('操作失败')
          }
        })
      }
    },
    // 周年确认
    znSave (data) {
      if (data !== '') {
        data.status = true
        data.text = '已确认'
      }
      const wqrList = []
      const qrList = []
      const list = this.znList
      list.forEach(item => {
        if (!item.status) {
          wqrList.push(item)
        } else {
          qrList.push(item)
        }
      })
      this.znList = []
      this.znList = [...wqrList, ...qrList]
      if (data !== '') {
        this.$request.post('/sso/hrUserAttrRemind/updateStatus', { 'id': data.id }).then(res => {
          if (res.data.code === 'OK') {
            this.$Message.success('操作成功')
          } else {
            this.$Message.warning('操作失败')
          }
        })
      }
    },
    // 兼职确认
    htzzSave (data) {
      if (data !== '') {
        data.status = true
        data.text = '已确认'
      }
      const wqrList = []
      const qrList = []
      const list = this.htzzList
      list.forEach(item => {
        if (!item.status) {
          wqrList.push(item)
        } else {
          qrList.push(item)
        }
      })
      this.htzzList = []
      this.htzzList = [...wqrList, ...qrList]
      if (data !== '') {
        this.$request.post('/sso/hrUserAttrRemind/updateStatus', { 'id': data.id }).then(res => {
          if (res.data.code === 'OK') {
            this.$Message.success('操作成功')
          } else {
            this.$Message.warning('操作失败')
          }
        })
      }
    },
    // 证书确认
    certSave (data) {
      if (data !== '') {
        data.status = true
        data.text = '已确认'
      }
      const wqrList = []
      const qrList = []
      const list = this.certList
      list.forEach(item => {
        if (!item.status) {
          wqrList.push(item)
        } else {
          qrList.push(item)
        }
      })
      this.certList = []
      this.certList = [...wqrList, ...qrList]
      if (data !== '') {
        this.$request.post('/sso/hrUserAttrRemind/updateStatus', { 'id': data.id }).then(res => {
          if (res.data.code === 'OK') {
            this.$Message.success('操作成功')
          } else {
            this.$Message.warning('操作失败')
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
@import url('./index.modules.less');

.info-box {
  height: 154px;
}

.info-card {
  position: absolute;
  left: 0;
  top: 0;
  width: 1.88rem;
  height: 90px;
  background: url('../../assets/images/common/bg-info.png') 60% 80% no-repeat !important;

  .avator-wrapper {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 50%);
    width: 110px;
    height: 110px;
    border-radius: 55px;
    overflow: hidden;
    cursor: pointer;

    .avator {
    width: 110px !important;
    height: 110px !important;
    border-radius: 55px !important;
      display: block;
    }

    .upload-avator {
      position: absolute;
      height: 45px;
      width: 110px;
      line-height: 45px;
      bottom: 0;
      opacity: 0;
      background: rgba(0, 0, 0, 0.4);
      width: 100%;
      color: #FFFFFF;
      transition: .3s;
      text-align: center;
      font-size: 12px;
    }

    &:hover {
      .upload-avator {
        opacity: 1;
      }
    }
  }
}

.name-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .name {
    text-align: center;
    font-size: 28px;
    font-weight: 500;
  }

  .number {
    margin: 6px 0;
    padding: 0 6px;
    display: inline-block;
    background: color-mix(in srgb, var(--primary-color, #E5A135) 20%, transparent);
    border-radius: 0.02rem;
    font-family: PingFangSC, PingFang SC;
    font-size: 0.05rem;
    color: var(--primary-color, #E5A135);
    text-align: left;
    font-style: normal;
  }
}

.button-box {
  margin-top: 24px;
  display: flex;

  .button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 36px;
    border-radius: 6px;
    border: 1px solid var(--primary-color, #E5A135);
    font-size: 14px;
    color: var(--primary-color, #E5A135);

    &:first-child {
      margin-right: 34px;
    }
  }
}

.border-bottom {
  width: 328px;
  height: 1px;
  border: 1px solid #F0F0F0;
  margin: 24px 0;
}

.links-items {
  padding: 0 !important;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.8;
  }

  img {
    width: 36px !important;
    height: 36px !important;
    border-radius: 18px !important;
  }
}

.info-item {
  display: flex;
  font-size: 14px;
  color: #333333;
  margin-top: 16px;

  .title {
    width: 116px;
  }

  .text {}
}
.modal-container {
  display: flex;
  align-items: center;
  justify-content: center;

  .notice-title {
    text-align: center;
    padding-bottom: 10px;
  }

  .notice-date {
    font-size: 14px;
    text-align: center;
    padding-bottom: 10px;
    border-bottom: 2px dashed #000;
    margin-bottom: 10px;
  }

  .ivu-modal {
    top: 0;
  }

  .ivu-modal-body {
    padding: 0;
    padding-top: 16px;
  }

  .modal-title {
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
  }

  .search-btn {
    display: flex;
    justify-content: space-between;

    .btn-left {
      display: flex;

      .btn-item {
        width: 80px;
        height: 30px;
        border-radius: 5px;
        padding-top: 5px;
        margin: 0 10px;
        text-align: center;
        cursor: pointer;
      }

      .btnActive {
        border-bottom: 3px;
        border-bottom-style: solid;
        color: #fff;
      }
    }

    .btn-right {
      margin-right: 50px;
    }
  }

  .btn-dc {
    margin: 0 20px 10px 10px;
    text-align: right;
  }

  .modal-content {
    display: flex;
    // justify-content: center;
    // align-items: center;
    flex-wrap: wrap;
    // height: 520px;
    max-height: 520px;
    min-height: 130px;
    overflow-y: auto;

    &-center {
      justify-content: center;
    }

    .items {
      flex: 0 0 20%;
      position: relative;
      box-sizing: border-box;
      padding: 12px;
      text-align: center;

      img {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        margin-bottom: 8px;
      }

      .name {
        text-align: center;
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        height: 44px;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;

        // white-space: nowrap;
        &[active] {
          color: #C8291D;
        }
      }

      .icon-normal {
        width: 38px;
        height: 38px;
        margin: 22px;
      }

      .back-name {
        line-height: 22px;
        height: auto;
      }

      .bj-light {
        position: absolute;
        top: 22px;
        left: 20px;
        width: 64px;
        height: 64px;
        background: #C8291D;
        border-radius: 8px;
        opacity: 0.5;
      }

      .checked {
        position: absolute;
        right: 26%;
        top: 12px;
        border: 2px solid #FFFFFF;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #C8291D;
        display: flex;
        justify-content: center;
        align-items: center;

        .icon {
          color: #FFFFFF;
          font-size: 16px;
        }
      }
    }

    .skin-box {
      width: 64px;
      height: 64px;
      border-radius: 50%;
    }

    .certificatesList {
      width: 100%;
      padding: 1% 3%;
      display: flex;
      border-bottom: 1px solid #eee;
      justify-content: space-between;

      .item:first-child {
        width: 90%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;

        .item-index {
          display: inline-block;
          padding: 0px 6px;
          height: 21px;
          text-align: center;
          color: #fff;
          border-radius: 50%;
          margin-right: 30px;
        }
      }

      .item:last-child {
        border-left: 2px solid red;
      }
    }

    .certificatesList:hover {
      background-color: #eee;
    }
  }

  .error-msg {
    padding: 0 24px;
    margin-bottom: 20px;

    > div {
      margin-bottom: 8px;
      font-size: 14px;
      color: #333;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .qd-msg {
      display: flex;
      justify-content: space-between;
      text-align: center;
      color: #fff;
      margin-top: 10px;

      .msg-item {
        width: 24%;
        height: 25px;
        line-height: 25px;
        background: #fff;
        border: 1px solid #ddd;
      }
    }
  }

  .modal-footer {
    display: flex;
    justify-content: space-between;
    padding: 0 24px;

    .button {
      width: 150px;
    }
  }
}
</style>
